<template>
  <div>
    <main class="main-content">
      <section class="login-section">
        <div class="container">
          <div class="login-inner">
            <div class="login-block">
              <div class="login-block__title">
                <img
                  src="/images/useful/svg/logo-sm.svg"
                  alt="logo small"
                  class="login-block__logo" /><span>Log In</span>
              </div>
              <div class="login-block__error" v-if="error">
                <p class="login-block__error__title">
                  The username or password is not correct.
                </p>
                <!-- <p class="login-block__error__action">Did you <a href="javascript:void(0)" @click="reset = true">forget your password?</a></p> -->
              </div>
              <form @submit="login" class="login-block__form">
                <div class="form-control-group">
                  <span class="form-control-label">Login or Email Address</span>
                  <div class="form-control-wrap">
                    <input
                      type="text"
                      placeholder="Your Login"
                      class="form-control"
                      v-model="email" />
                  </div>
                </div>
                <div class="form-control-group">
                  <span class="form-control-label">Password</span>
                  <div class="form-control-wrap">
                    <input
                      :type="passView ? 'text' : 'password'"
                      placeholder="Your Password"
                      class="form-control"
                      v-model="password" />
                    <button
                      type="button"
                      class="form-control-icon"
                      @click="passView = !passView">
                      <svg width="1em" height="1em" class="icon icon-eye">
                        <use
                          xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-eye"></use>
                      </svg>
                    </button>
                  </div>
                </div>
                <div class="login-block__form__submit">
                  <button type="button" class="btn btn--green" @click="login">
                    <span>Log In</span>
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </main>
    <div class="modal-wrapper" v-if="reset">
      <div class="modal-backdrop"></div>
      <div class="modal-inner">
        <div class="edit-popup popup--recovery">
          <div class="edit-popup__header">
            <div class="edit-popup__title">
              <span>Recovery Password</span>
            </div>
            <div class="edit-popup__close" @click="reset = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                  xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <form action="javascript:void(0)" class="edit-popup__inner">
            <div class="form-control-group">
              <div class="form-control-wrap">
                <input
                  type="email"
                  Placeholder="Email"
                  v-model="emailReset"
                  class="form-control" />
              </div>
            </div>
            <button
              type="submit"
              class="btn btn--green edit-popup__submit"
              @click="resetPassword">
              <span>Send</span>
            </button>
          </form>
        </div>
      </div>
    </div>
    <div class="modal-wrapper" v-if="mfa.popup">
      <div class="modal-backdrop" ></div>
      <div class="modal-inner" @click="mfa.popup = false">
        <div class="edit-popup login-mfa--popup" @click.stop>
          <div class="edit-popup__header">
            <div class="edit-popup__title">
            </div>
            <div class="edit-popup__close" @click="mfa.popup = false">
              <svg width="1em" height="1em" class="icon icon-close">
                <use
                    xlink:href="/images/useful/svg/theme/symbol-defs.svg#icon-close"></use>
              </svg>
            </div>
          </div>
          <div class="login-mfa__title">
              <span class="login-mfa__title-logo">
                <svg width="36" height="35" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M0.343985 16.6738L16.7588 0.34224C16.9794 0.123091 17.2783 0 17.5901 0C17.9018 0 18.2008 0.123091 18.4213 0.34224L34.8361 16.6738C35.0564 16.8933 35.1801 17.1907 35.1801 17.5009C35.1801 17.811 35.0564 18.1085 34.8361 18.3279L18.4213 34.6595C18.2002 34.8776 17.9014 35 17.5901 35C17.2787 35 16.9799 34.8776 16.7588 34.6595L0.343985 18.3279C0.123719 18.1085 0 17.811 0 17.5009C0 17.1907 0.123719 16.8933 0.343985 16.6738Z" fill="url(#paint0_linear_345_115)"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M25.6232 25.8046C25.6085 25.449 25.5245 25.1258 24.9326 24.6828C24.7102 24.5161 24.5632 23.3861 24.4688 22.3375C24.3911 21.4717 24.5779 21.4107 25.2328 21.0998C25.2686 21.0831 25.3093 21.0793 25.3477 21.089C25.3862 21.0986 25.4198 21.1212 25.4427 21.1526L25.4889 21.2197C25.5002 21.2351 25.5087 21.2523 25.5141 21.2705L25.7953 23.1768C25.8079 23.2276 25.8415 23.7073 25.8688 23.9267C25.9863 24.8169 26.5887 25.0811 27.4514 25.0486C27.8208 25.0344 28.3602 24.9246 28.3812 24.6218C28.4316 23.9511 28.0412 23.4471 28.0852 23.0386C28.5197 21.5367 28.9542 20.1933 29.4034 18.7504C29.6589 17.9552 29.8374 17.1387 29.9365 16.3115C30.1705 14.4364 30.0409 12.5354 29.5545 10.7063C29.4978 10.4746 29.4055 10.056 29.2942 9.69016C29.2061 9.28779 28.993 8.92115 28.6834 8.63944C28.1901 8.16973 27.5876 7.82128 26.9266 7.62326C25.9861 7.3318 24.9938 7.2308 24.0112 7.32654C23.2472 7.39767 22.9303 7.65578 22.3006 8.22687C21.2301 9.20036 21.0811 9.28572 19.8007 9.94827C19.6654 9.99213 19.5528 10.0849 19.4863 10.2072C19.4198 10.3295 19.4047 10.4719 19.4439 10.6047C19.6181 11.0579 19.7063 11.3628 19.9246 11.5782C20.0355 11.7012 20.1816 11.7897 20.3444 11.8323L19.5972 12.4663C18.575 13.1899 18.214 13.3707 17.0134 13.0964C15.8434 12.8135 14.6489 12.6359 13.4452 12.5659C11.399 12.4992 9.39975 13.1682 7.83262 14.4438C6.27311 15.7567 5.94358 17.5777 4.73249 19.1812C4.24477 19.8364 3.66955 20.4262 3.02186 20.9351C2.73431 21.1607 2.39218 21.3863 2.05635 21.6139C1.65335 21.8802 1.22937 22.1993 1.62187 22.6606C2.04166 23.1646 2.71332 23.0467 3.31361 22.874C4.5835 22.4689 5.77511 21.8625 6.83982 21.0794C6.95317 20.9981 7.11268 21.0794 7.0896 21.3579L6.65092 23.7052C6.62363 23.9654 6.46411 24.7539 6.6887 25.0628C7.25541 25.8453 7.75286 26.1887 8.83381 26.0973C9.17225 26.087 9.50559 26.0146 9.81611 25.8839C10.1205 25.7254 10.1289 25.4571 10.0932 25.199C10.0617 24.9734 9.59153 24.51 9.28298 24.254C9.23471 24.2235 9.241 24.1584 9.2536 24.1036C9.32706 23.7987 9.56004 23.8272 9.88328 23.6971C10.599 23.4146 11.2518 23.124 11.745 22.2562C11.7591 22.2121 11.7869 22.1733 11.8246 22.1451C11.8623 22.117 11.908 22.1008 11.9556 22.0988C12.0032 22.0967 12.0503 22.109 12.0903 22.1339C12.1304 22.1589 12.1616 22.1951 12.1795 22.2379L12.083 23.2947C12.1144 24.254 12.6329 24.5893 13.5522 24.6889C14.1651 24.7559 14.8347 24.7051 15.0425 24.5527C15.1465 24.4324 15.1997 24.2785 15.1915 24.1219C15.1159 23.819 14.9942 23.7154 14.6332 23.3394C14.5597 23.3069 14.545 23.0711 14.5702 22.998L14.9438 22.2074C15.0865 21.9533 15.1537 21.8741 15.4853 21.8924C16.9126 22.0956 17.9747 22.5874 20.2751 21.9818C20.3083 21.9728 20.3436 21.9738 20.3762 21.9847C20.4088 21.9956 20.4373 22.0159 20.4577 22.0428L20.5585 22.1769L20.5774 22.1972C21.377 23.3028 22.1935 24.5588 22.8862 25.7457C23.0171 25.9575 23.2195 26.119 23.4592 26.203C23.6691 26.2761 24.5087 26.2538 24.9494 26.203C25.0286 26.1934 25.1071 26.1792 25.1845 26.1603C25.2513 26.1455 25.3166 26.1251 25.3797 26.0993C25.535 26.0262 25.6316 25.9327 25.6232 25.8046Z" fill="#000002"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M21.171 11.6665L23.8177 12.2384C23.8596 12.2493 23.8973 12.273 23.9255 12.3065C23.9537 12.34 23.9712 12.3815 23.9755 12.4255L24.1859 15.4615C24.1878 15.4849 24.1831 15.5083 24.1723 15.5289C24.1615 15.5495 24.145 15.5664 24.1249 15.5776C24.1053 15.5903 24.0827 15.5969 24.0596 15.5969C24.0365 15.5969 24.0139 15.5903 23.9944 15.5776L21.8338 13.9414C21.8209 13.9317 21.8062 13.9248 21.7907 13.9211C21.7751 13.9174 21.759 13.917 21.7433 13.9199C21.7273 13.9217 21.7118 13.9271 21.698 13.9356C21.6842 13.9442 21.6724 13.9557 21.6633 13.9693L20.1233 16.1947C20.1062 16.2205 20.08 16.2385 20.0502 16.2449C20.0203 16.2513 19.9893 16.2456 19.9634 16.2291L19.5069 15.9432C19.4819 15.9264 19.4515 15.9201 19.4221 15.9257C19.3926 15.9313 19.3665 15.9484 19.3491 15.9733L18.5076 17.0828C18.4891 17.1076 18.4621 17.1243 18.432 17.1295C18.4019 17.1347 18.371 17.128 18.3456 17.1107L16.5909 15.9002C16.5717 15.888 16.5494 15.8815 16.5268 15.8815C16.5041 15.8815 16.4819 15.888 16.4626 15.9002C16.4425 15.9118 16.4262 15.9292 16.4158 15.9503C16.4053 15.9713 16.4011 15.995 16.4037 16.0184L16.6141 18.4116C16.616 18.4359 16.6108 18.4604 16.5992 18.4818C16.5876 18.5032 16.5701 18.5206 16.5489 18.532C16.5274 18.5436 16.503 18.5482 16.4789 18.5452C16.4548 18.5421 16.4322 18.5315 16.4142 18.5148L13.2206 15.6873C13.2075 15.6755 13.192 15.6669 13.1753 15.662C13.1585 15.6572 13.1409 15.6563 13.1238 15.6593C13.1068 15.6615 13.0904 15.6674 13.0759 15.6767C13.0614 15.686 13.049 15.6984 13.0396 15.7131L11.7605 17.7708L11.3397 17.6611C11.3152 17.6549 11.2894 17.6568 11.266 17.6664C11.2425 17.6761 11.2227 17.693 11.2093 17.7149L10.5928 18.7212C10.5837 18.7369 10.5712 18.7503 10.5563 18.7604C10.5413 18.7704 10.5243 18.7769 10.5066 18.7792C10.4886 18.7818 10.4703 18.7801 10.4531 18.7741C10.4359 18.7681 10.4204 18.7581 10.4077 18.7448L10.2457 18.5857C10.2341 18.5734 10.22 18.5639 10.2043 18.558C10.1886 18.552 10.1719 18.5498 10.1552 18.5513C10.1389 18.5511 10.1227 18.555 10.1081 18.5624C10.0934 18.5699 10.0808 18.5808 10.0711 18.5943L8.63625 20.3252C8.61998 20.3457 8.59759 20.3601 8.5725 20.3664C8.54742 20.3726 8.52103 20.3702 8.49739 20.3596C8.47331 20.349 8.45329 20.3307 8.44037 20.3074C8.42745 20.2841 8.42236 20.2571 8.42586 20.2306L8.80876 17.1731C8.81194 17.1455 8.80601 17.1176 8.79191 17.0938C8.7778 17.07 8.75634 17.0518 8.73092 17.0419C8.70568 17.0321 8.6779 17.0314 8.65224 17.04C8.62658 17.0486 8.60459 17.066 8.58996 17.0892C7.03942 19.42 6.36829 20.4155 4.00565 21.8841C3.16411 22.4087 2.36464 22.7936 2.22368 22.5055C2.14584 22.3485 2.26155 22.2302 2.41303 22.1292C2.85155 21.8549 3.27312 21.5533 3.67535 21.2261C4.45624 20.5708 5.13513 19.7979 5.68874 18.934C6.41878 17.7816 6.95106 16.3259 7.78208 15.1928C8.86767 13.7221 11.1167 12.8276 12.8713 12.7136C13.9927 12.6448 15.1182 12.8061 16.6772 13.1609C19.2481 13.7457 19.1703 13.1996 21.171 11.6665Z" fill="white"/>
                  <path fill-rule="evenodd" clip-rule="evenodd" d="M24.8445 8.33351L25.277 8.82442C25.287 8.83583 25.2992 8.84522 25.313 8.85204C25.3268 8.85887 25.3418 8.86299 25.3573 8.86417C25.3731 8.86531 25.3889 8.86324 25.4038 8.8581C25.4187 8.85297 25.4323 8.84488 25.4438 8.83436L25.7733 8.55611C25.7848 8.54558 25.7984 8.5375 25.8133 8.53236C25.8282 8.52723 25.844 8.52516 25.8598 8.52629C25.8918 8.52952 25.9213 8.54446 25.9422 8.56803L26.7392 9.51607C26.7521 9.53146 26.769 9.54326 26.7882 9.55025C26.8074 9.55724 26.8282 9.55916 26.8484 9.55582L27.6887 9.44253C27.8946 9.4167 27.9399 9.44253 28.0202 9.53197L28.879 10.4939L29.0376 10.6807L29.2436 10.9212C29.2493 10.9287 29.2577 10.9341 29.2671 10.9362C29.2765 10.9384 29.2864 10.9373 29.2951 10.9332C29.3031 10.9287 29.3095 10.9218 29.3132 10.9136C29.3169 10.9054 29.3178 10.8962 29.3157 10.8874L29.2662 10.6887L28.9923 9.60153C28.7596 8.67933 28.2777 8.30171 27.4189 7.84061C26.56 7.37951 24.3502 7.0456 23.479 7.52658C23.2871 7.63171 23.114 7.76592 22.9662 7.92408C22.7273 8.16854 22.6717 8.25401 22.7603 8.37127C22.9106 8.55412 22.9889 8.47661 23.201 8.43487L24.4367 8.19438C24.6982 8.15264 24.6982 8.15264 24.8445 8.33351Z" fill="white"/>
                  <defs>
                  <linearGradient id="paint0_linear_345_115" x1="17.6385" y1="0.153799" x2="17.5572" y2="34.8542" gradientUnits="userSpaceOnUse">
                  <stop stop-color="#77B017"/>
                  <stop offset="1" stop-color="#679C0D"/>
                  </linearGradient>
                  </defs>
                </svg>
              </span>
            <span>Two-Factor Authentication</span>
          </div>
          <div class="login-mfa__notification">
            <span class="login-mfa__notification-text">
              Please enter the authorization code below.
            </span>
          </div>
          <div class="login-mfa__error" v-if="mfa.error">
            <span class="login-mfa__error-text">
              Error! Wrong code!
            </span>
          </div>
          <form v-on:submit.prevent="sendMfaCode()">
            <div class="login-mfa__code-wrapper">
              <div class="login-mfa__code-inner">
                <div class="login-mfa__code-title">
                  Your Code:
                </div>
                <div class="login-mfa__code-input">
                  <input type="text" placeholder="Please type" v-model="mfa.code">
                </div>
              </div>
            </div>
            <div class="login-mfa__submit-button">
              <button class="btn btn--green" type="submit">
                <span>Send</span>
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {auth, getUser, reset, setAuthData} from '@/utilites/api'
import {validateEmail} from '@/utilites/functions'

import jwt_decode from 'jwt-decode'

export default {
  data() {
    return {
      email: '',
      password: '',
      passView: false,
      error: false,
      reset: false,
      emailReset: '',
      mfa: {
        popup: false,
        code: null,
        error: false
      }
    }
  },
  props: ['user', 'referer'],
  beforeCreate() {
    document.title = 'Login'
  },
  mounted() {
    window.addEventListener('click', (event) => {
      if (
        !event.target.closest('.edit-popup') &&
        !event.target.closest('.btn')
      ) {
        this.reset = false
      }
    })
  },
  methods: {
    login() {
      if (this.email.trim().length) {
        auth(this.email, this.password)
          .then((res) => {
            let decode = jwt_decode(res.access_token)
            setAuthData(res)
            getUser(res.access_token, decode.sub)
              .then((user) => {
                if (user === 'error') {
                  this.error = true
                  return false
                }
                this.$emit('setUser', {
                  ...res,
                  id: +decode.sub,
                  data: user,
                })
                this.error = false
              })
              .catch((error) => {})
            this.error = false
          })
          .catch((error) => {
            if (error.response.status === 400 && error.response.data.code === 'TWO_FACTOR_CODE_MISSING') {
              this.mfa.popup = true
              this.mfa.error = false
              this.mfa.code = ''
            } else {
              this.error = true
            }
          })
      } else {
        this.error = true
      }
    },
    resetPassword() {
      if (validateEmail(this.emailReset)) {
        reset(this.emailReset).then((res) => {
          this.reset = false
        })
      }
    },
    sendMfaCode() {
      if (this.mfa.code && this.mfa.code.trim()) {
        auth(this.email, this.password, this.mfa.code)
            .then((res) => {
              let decode = jwt_decode(res.access_token)
              setAuthData(res)
              getUser(res.access_token, decode.sub)
                  .then((user) => {
                    if (user === 'error') {
                      this.error = true
                      return false
                    }
                    this.$emit('setUser', {
                      ...res,
                      id: +decode.sub,
                      data: user,
                    })
                    this.error = false
                  })
                  .catch((error) => {})
              this.error = false
            })
            .catch((error) => {
              this.error = false
              this.mfa.error = true
            })
      }
    }
  },
  watch: {
    email() {
      this.error = false
    },
    password() {
      this.error = false
    },
    user() {
      this.$router.push(this.referer || '/clients')
    },
    mfa: {
      handler(newMfa) {
        if (newMfa.code.trim().length === 6) {
          this.sendMfaCode();
        }
      },
      deep: true
    },
  },
}
</script>
<style scoped lang="scss">
.login-mfa {
  &--popup {
    width: 100%;
    max-width: 450px;
  }
  &__title {
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    line-height: 19px;
    margin: 1rem 0;

    &-logo {
      margin-right: 1rem;
    }
  }

  &__notification {
    border-radius: 5px;
    background: rgba(194, 194, 194, 0.2);
    display: flex;
    justify-content: center;
    padding: 1.5rem 0.5rem;
    margin: 1.5rem;

    &-text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }
  }

  &__error {
    border-radius: 5px;
    background: rgba(244, 152, 152, 0.2);
    display: flex;
    justify-content: center;
    padding: 1.5rem 0.5rem;
    margin: 1.5rem;

    &-text {
      font-size: 12px;
      line-height: 14px;
      font-weight: 500;
    }
  }

  &__code {
    &-wrapper {
      display: flex;
      flex-direction: column;
      padding: 1.5rem 0.5rem;
      font-size: 12px;
      line-height: 14px;
      margin: 1.5rem;
      align-items: center;
    }

    &-inner {
      width: 50%;
    }

    &-title {
      margin-bottom: 0.4375rem;
      font-weight: 500;
    }

    &-input input {
      border: 1px solid #BCBCBC;
      border-radius: 3px;
      outline: none;
      width: 100%;
      padding: 1rem 1.2rem;
    }
  }

  &__submit-button {
    color: white;
    display: flex;
    justify-content: center;
    margin-bottom: 2rem;
  }
}
</style>